import { render, staticRenderFns } from "./CustomerDisplayHeader.vue?vue&type=template&id=b46b2c62"
import script from "./CustomerDisplayHeader.vue?vue&type=script&lang=js"
export * from "./CustomerDisplayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports